
function projecao(RSU, constante, anoAtual, anoFinal, anoInicial) {
    // //Insere os anos no vetor resultado total
    let triang = [];
    for (let i = 0; i < anoAtual + 20 || i < anoFinal + 20; i++)
        triang[i] = {
            ano: anoInicial + i,
            quantidade: 0
        }

    //Calcula a emissão de cada quantidade de cada ano
    for (let year = 0; year <  anoAtual + 20 || year < anoFinal + 20; year++)
        //Navega pelos items, sendo cada item uma quantidade de RSU inserida
        for (let item = 0; item <= year && item < RSU.length; item++) 
            triang[year].quantidade += (item < RSU.length) ? constante[year - item] * parseFloat(RSU[item].quantidade) : constante[year - item] * parseFloat(RSU[0].quantidade);
        
    return triang;
}
                
function calculo(dados, PHI, GWPCH4, parametros) {
    const RSU = dados;

    const date = new Date();
    const anoAtual = date.getFullYear();
    const anoFinal = RSU[RSU.length - 1].ano;
    const anoInicial = RSU[0].ano;

    const numAnoAtual = anoAtual%100;
    const numAnoFinal = anoFinal%100;

    const OX = parametros  != null ? parametros.OX : 0.1;
    const fy = parametros  != null ? parametros.fy : 0;
    const F = parametros   != null ? parametros.F : 0.5;
    const MCF = parametros != null ? parametros.MCF : 1;
    const kji = parametros != null ? parseFloat(parametros.kji) : parseFloat(1);

    const fator1 = PHI * (1 - fy) * GWPCH4 * (1 - OX) * 16 / 12 * (F) * (0.5) * MCF;

    var constTotal = new Array(30);
    var constAlimentos = new Array(30);
    var constPapel = new Array(30);
    var constTexteis = new Array(30);
    var constMadeira = new Array(30);
    var constjardins = new Array(30);

    var result = new Array(2);
    result[0] = []; //separado por tipo de RSU
    result[1] = new Array(30); //total

    if(RSU === null)
        return null

    RSU.sort((a, b) => parseFloat(a.ano) - parseFloat(b.ano));
        

    //Calcula uma constante, que seria o produto de todos os números exceto pelo o RSU na formula, para cada tipo em cada ano
    for (let x = 1; x <=  numAnoAtual + 20 || x <= numAnoFinal + 20; x++) {
                                    //porcentagem                 exp^(-k(y-x))                    1 - exp  ^ (-kj) fator1 é a parte fora do somatorio (ou seja isso é uma distribuitiva)
        constAlimentos[x - 1] = ((45.3 / 100) * (15 / 100) * (Math.E ** (-0.185 * (x - 1))) * (1 - Math.E ** (-0.185))) * fator1;
        constPapel[x - 1] = ((10.4 / 100) * (40 / 100) * (Math.E ** (-0.06 * (x - 1))) * (1 - Math.E ** (-0.06))) * fator1;
        constTexteis[x - 1] = ((5.6 / 100) * (24 / 100) * (Math.E ** (-0.03 * (x - 1))) * (1 - Math.E ** (-0.03))) * fator1;
        constMadeira[x - 1] = ((1.4 / 100) * (43 / 100) * (Math.E ** (-0.06 * (x - 1))) * (1 - Math.E ** (-0.06))) * fator1;
        constjardins[x - 1] = ((14.1 / 100) * (20 / 100) * (Math.E ** (-0.1 * (x - 1))) * (1 - Math.E ** (-0.1))) * fator1;
        
        constTotal[x - 1] = constAlimentos[x - 1] + constPapel[x - 1] + constTexteis[x - 1] + constMadeira[x - 1] + constjardins[x - 1];
    }

    result[1] = projecao(RSU, constTotal, numAnoAtual, numAnoFinal, anoInicial);

    result[0][0] = projecao(RSU, constAlimentos, numAnoAtual, numAnoFinal, anoInicial);
    result[0][1] = projecao(RSU, constMadeira, numAnoAtual, numAnoFinal, anoInicial);
    result[0][2] = projecao(RSU, constPapel, numAnoAtual, numAnoFinal, anoInicial);
    result[0][3] = projecao(RSU, constTexteis, numAnoAtual, numAnoFinal, anoInicial);
    result[0][4] = projecao(RSU, constjardins, numAnoAtual, numAnoFinal, anoInicial);

    return result;
}

//Usa a função de calculo com diferentes parametros e armazena no resultado
export function calcularProjecao(dados, parametros) {
    if(dados){
        let resultado = {
            metanoConservador: calculo(dados, 0.5, 1, parametros),  //metano 
            metanoRecomendado: calculo(dados, 0.75, 1, parametros),  //metano 
            coConservador: calculo(dados, 0.5, 25, parametros),  //CO2 
            coRecomendado: calculo(dados, 0.75, 25, parametros),  //CO2 
        };
        return resultado;
    } 
}